import { createComponent } from '../lib';
import { VmCaptionControl, VmControl, VmIcon, VmTooltip } from '@vime/core';
import { define } from '../lib';
define('vm-caption-control', VmCaptionControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
;
export default createComponent('vm-caption-control', new Set(['showIcon', 'hideIcon', 'tooltipPosition', 'tooltipDirection', 'hideTooltip', 'icons', 'keys', 'i18n', 'playbackReady', 'textTracks', 'isTextTrackVisible']));
//# sourceMappingURL=CaptionControl.jsx.map